export default __webpack_public_path__ + "static/media/eyeOff.8fc9b436.svg";